import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";

export const DS_FILE_FALLBACK_ICON: DSIconName = "file";

export const DS_IMAGE_FILE_PREVIEW_EXTENSIONS = ["avif", "bmp", "gif", "ico", "jpg", "jpeg", "png", "webp"] as const;

export const DS_FILE_TYPE_ICONS = [
  { icon: "file-pdf", extensions: ["pdf"] },
  { icon: "file-docx", extensions: ["doc", "docx", "odt", "rtf"] },
  { icon: "file-xlsx", extensions: ["xls", "xlsx", "ods"] },
  { icon: "file-csv", extensions: ["csv", "tsv"] },
  { icon: "file-pptx", extensions: ["ppt", "pptx", "odp"] },
  { icon: "file-text", extensions: ["txt", "log"] },
  { icon: "file-md", extensions: ["md", "markdown"] },
  { icon: "file-json", extensions: ["json"] },
  { icon: "file-ics", extensions: ["ics"] },
  {
    icon: "file-image",
    extensions: [...DS_IMAGE_FILE_PREVIEW_EXTENSIONS, "tif", "tiff", "heic"],
  },
  { icon: "file-vector", extensions: ["svg", "ai", "eps", "psd", "sketch", "fig", "xd"] },
  { icon: "file-video", extensions: ["mp4", "mov", "avi", "mkv", "webm", "wmv", "mpg", "mpeg", "m4v"] },
  { icon: "file-audio", extensions: ["mp3", "wav", "m4a", "ogg", "aac", "flac", "wma", "opus"] },
  { icon: "file-zip", extensions: ["zip", "rar", "7z", "tar", "gz", "tgz", "bz2", "xz"] },
  {
    icon: "file-dev",
    extensions: [
      "js",
      "mjs",
      "cjs",
      "jsx",
      "ts",
      "tsx",
      "vue",
      "rb",
      "erb",
      "py",
      "java",
      "php",
      "go",
      "rs",
      "c",
      "h",
      "cpp",
      "cs",
      "swift",
      "kt",
      "sh",
      "sql",
      "html",
      "htm",
      "css",
      "scss",
      "less",
      "xml",
      "yml",
      "yaml",
      "toml",
    ],
  },
] as const satisfies readonly { icon: DSIconName; extensions: readonly string[] }[];
